import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { HourglassEmpty } from '@mui/icons-material';
import { en } from '../../locale';

interface LoadingFallbackProps {
  message?: string;
  fullScreen?: boolean;
}

/**
 * Composant de chargement pour React.Suspense
 * Utilisé lors du lazy loading des routes et composants
 */
export default function LoadingFallback({
  message = en.common.loading,
  fullScreen = false,
}: LoadingFallbackProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: fullScreen ? '100vh' : '400px',
        gap: 3,
        p: 4,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress
          size={60}
          thickness={4}
          sx={{
            color: theme.palette.primary.main,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <HourglassEmpty
            sx={{
              fontSize: 24,
              color: theme.palette.primary.main,
              opacity: 0.7,
            }}
          />
        </Box>
      </Box>

      <Typography
        variant="body1"
        sx={{
          color: theme.palette.text.secondary,
          fontWeight: 500,
          letterSpacing: '0.02em',
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}
